/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Final_PriceInputs */

const es_admin_billing_batch_final_price = /** @type {(inputs: Admin_Billing_Batch_Final_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio final`)
};

const en_admin_billing_batch_final_price = /** @type {(inputs: Admin_Billing_Batch_Final_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final price`)
};

/**
* | output |
* | --- |
* | "Final price" |
*
* @param {Admin_Billing_Batch_Final_PriceInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_final_price = /** @type {((inputs?: Admin_Billing_Batch_Final_PriceInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Final_PriceInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_final_price(inputs)
	return en_admin_billing_batch_final_price(inputs)
});
export { admin_billing_batch_final_price as "admin.billing.batch.final_price" }